import Nav from 'react-bootstrap/Nav'
import Navbar from 'react-bootstrap/Navbar'
import Image from 'react-bootstrap/Image'
import Offcanvas from 'react-bootstrap/Offcanvas'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import Logo from '../../assets/logo/logo.png'
import { Button } from 'react-bootstrap'
import { REDIRECT_URL } from '../../utils/constants'

function NavbarOffcanvas({ showMenu, setShowMenu }) {
  const location = useLocation()
  const navigate = useNavigate()
  const onClick = () => {
    setShowMenu(false)
    navigate('/contact')
    // window.scrollTo({ bottom: 0, behavior: 'smooth' })
  }
  const redirectUrl = () => {
    // redirect to an external login
    window.location.href = REDIRECT_URL
  }
  const className = (path = '/products') =>
    `ag-top-nav__link ${
      (path !== '/' && location.pathname.startsWith(path)) ||
      location.pathname === path
        ? 'is-active'
        : ''
    }`
  return (
    <Navbar.Offcanvas
      show={showMenu}
      placement='start'
      id='responsive-navbar-nav'
      className='ag-top-nav__drawer'
      onHide={() => setShowMenu(false)}
    >
      <div>
        <Offcanvas.Header
          closeButton
          onClick={() => setShowMenu(false)}
          className='ag-top-nav__drawer-head'
        >
          <Link to={'/'}>
            <Image src={Logo} alt='Actual Green Corporation' />
          </Link>
        </Offcanvas.Header>
        <Nav className='ag-top-nav__links'>
          <Link
            className={className('/')}
            to={'/'}
            onClick={() => setShowMenu(false)}
          >
            Home
          </Link>
          <Link
            className={className('/products')}
            to={'/products'}
            onClick={() => setShowMenu(false)}
          >
            Products
          </Link>
          <Link
            className={className('/documents')}
            to={'/documents'}
            onClick={() => setShowMenu(false)}
          >
            Documents
          </Link>
          <Link
            className={className('/about')}
            to={'/about'}
            onClick={() => setShowMenu(false)}
          >
            About Us
          </Link>
          <Button
            onClick={onClick}
            className='ag-top-nav__button ag-top-nav__button--outline'
          >
            Contact Us
          </Button>
          <Button
            onClick={redirectUrl}
            className='ag-top-nav__button ag-top-nav__button--login'
          >
            Login
          </Button>
        </Nav>
      </div>
    </Navbar.Offcanvas>
  )
}

export default NavbarOffcanvas
